/* eslint-disable no-unused-expressions */
import {CustomEase} from 'gsap/CustomEase';

import helpers from '../helpers';

gsap.registerPlugin(CustomEase);

const init = () => {
	let element = helpers.$document.find('#nav');
	let open = helpers.$document.find('#nav-trigger');
	let close = helpers.$document.find('#close-nav');
	let overlay = helpers.$document.find('.nav__overlay');
	let navigationWrapper = helpers.$document.find('.nav__wrapper');
	let itemService = helpers.$document.find('.service-ul .menu-el');
	let lineHorizontal = helpers.$document.find('.js-line-h');
	let linesVertical = helpers.$document.find('.js-line');
	let fade = helpers.$document.find('.js-m-fade');
	let model = helpers.$document.find('.nav__elements');
	let socials = helpers.$document.find('.nav__social');

	const timeLine = gsap.timeline({
		paused: true,
	});

	let a = {
		ease1: CustomEase.create('custom', '.45,.01,.07,1'),
		ease2: CustomEase.create('custom', 'M0,0 C0.496,0.174 0.396,1 1,1'),
		ease3: CustomEase.create('custom', 'M0,0 C0.35,0.028 0.338,1 1,1'),
		ease4: CustomEase.create('custom', '.58,.01,.16,1'),
		ease5: CustomEase.create('custom', '.075, .82, .165, 1'),
		ease6: CustomEase.create('custom', '.65, .05, .36, 1'),
	};

	timeLine
		.set(element, {
			visibility: 'visible',
			alpha: 1,
		}, 0)
		.to(close, {
			duration: 0.5,
			autoAlpha: 1,
		}, 0.3)
		.to(overlay, {
			duration: 1,
			scale: 1,
			transformOrigin: 'left right',
			ease: a.ease1,
		}, 0)
		.to(navigationWrapper, {
			duration: 0.5,
			autoAlpha: 1,
			ease: a.ease2,
		}, 0.2)
		.to(lineHorizontal, {
			stagger: 0.1,
			scaleX: 1,
			duration: 0.8,
			transformOrigin: 'top left',
			ease: a.ease1,
		}, 0.3)
		.to(linesVertical, {
			stagger: 0.3,
			scaleY: 1,
			duration: 1,
			transformOrigin: 'top left',
			ease: a.ease1,
		}, 0.3)
		.to(fade, {
			stagger: 0.1,
			duration: 1,
			autoAlpha: 1,
			ease: a.ease2,
		}, 0.4)
		.to(itemService, {
			stagger: 0.1,
			y: 0,
			duration: 1,
			autoAlpha: 1,
			ease: a.ease2,
		}, 0.4)
		.from([socials, model], {
			duration: 1,
			y: 0,
			autoAlpha: 0,
			ease: a.ease2,
		}, 0.45);

	function modelRotate(event) {
		let div = document.querySelector('.nav__item--1');
		let bb = div.getBoundingClientRect();
		let cx = bb.left + bb.width / 2;
		let cy = bb.top + bb.height / 2;
		let angle = Math.atan2(event.y - cy, event.x - cx);
		let deg = angle * 180 / Math.PI;

		if (deg > -10 && deg > 125) {
			div.style.transform = `rotate(${deg}deg)`;
		}
	}

	const openMenu = () => {
		timeLine.play();
		timeLine.timeScale(1);

		element.addClass('is-active');

		if (!helpers.isMobile) {
			helpers.lockScroll(true, helpers.$header.find('#nav'), 'nav');
		}

		helpers.$document.trigger('bg-play', '.nav__bg');

		document.addEventListener('mousemove', modelRotate);
	};

	const closeMenu = () => {
		timeLine.timeScale(1);
		timeLine.reverse();

		element.removeClass('is-active');

		if (!helpers.isMobile) {
			helpers.lockScroll(false, helpers.$header.find('#nav'), 'nav');
		}

		helpers.$document.trigger('bg-destroy', '.nav__bg');

		document.removeEventListener('mousemove', modelRotate);
	};

	open.on('click', openMenu);
	close.on('click', closeMenu);

	helpers.$document.on('menu-close', closeMenu);
};

export default {
	init,
};
